import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "stock-detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "table-container"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import MarketTypeTab from '@/components/holdings/MarketTypeTab.vue'
import TableEmpty from '@/components/holdings/TableEmpty.vue'
import useStock from '@/hooks/holdings/useStock'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { formatThousandsKeepDecimal } from '@/utils/num_format'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'StockDetail',
  setup(__props) {

const store = useStore()

const router = useRouter()

const marketTypeList = ref([
  {
    label: '港股',
    value: 'HK'
  },
  {
    label: '美股',
    value: 'US'
  },
  {
    label: 'A股',
    value: 'A'
  }
])

// 持仓列表
const stockPosPageList = computed(() => store.state.holdings.stockPosPageList)


const assetsInfo = computed(() => {
  return [
    {
      label: store.state.holdings.marketTypeActive.label + '总市值',
      value: formatThousandsKeepDecimal(store.state.holdings.fundAccMarketList.marketValueDisplay, 2)
    },
    {
      label: '现金可提',
      value: formatThousandsKeepDecimal(store.state.holdings.fundAccMarketList.fetchBalanceDisplay, 2),
      icon: 'fetchBalanceDisplay'
    },
    {
      label: '最大购买力',
      value: formatThousandsKeepDecimal(store.state.holdings.fundAccMarketList.enableBalanceDisplay, 2),
      icon: 'enableBalanceDisplay'
    },
    {
      label: '冻结资金',
      value: formatThousandsKeepDecimal(store.state.holdings.fundAccMarketList.frozenBalanceDisplay, 2)
    }
  ]
})

const { queryStockData, loading } = useStock()

const handleBuy = (row: any) => {
  const { exchangeType, enableAmount, stockCode, stockNameGb }: any = row
  router.push({
    name: 'BulkTrading',
    params: {
      stockInfo: JSON.stringify({ exchangeType, enableAmount, stockCode, stockNameGb })
    }
  })
}

const handleSell = (row: any) => {
  const { exchangeType, enableAmount, stockCode, stockNameGb }: any = row
  router.push({
    name: 'BulkTrading',
    params: {
      stockInfo: JSON.stringify({ exchangeType, entrustAmount: enableAmount, stockCode, stockNameGb })
    }
  })
}

const formatIncomeBalanceColor = (incomeBalance: string) => {
  incomeBalance = incomeBalance.replace(',', '')
  if (Number(incomeBalance) > 0) {
    return 'red'
  } else if (Number(incomeBalance) < 0) {
    return 'green'
  } else {
    return ''
  }
}

onMounted(() => {
  queryStockData()
})


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MarketTypeTab, {
      marketTypeList: marketTypeList.value,
      assetsInfo: assetsInfo.value,
      loadFunc: _unref(queryStockData)
    }, null, 8, ["marketTypeList", "assetsInfo", "loadFunc"]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title" }, "持仓", -1)),
    (_unref(loading) || stockPosPageList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: stockPosPageList.value,
            "show-overflow-tooltip": "",
            "header-cell-class-name": "stock-detail-table-header-cell",
            "row-class-name": "stock-detail-table-row",
            style: {"width":"100%"},
            "max-height": "300"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "stockCode",
                label: "代码"
              }),
              _createVNode(_component_el_table_column, {
                prop: "stockNameGb",
                label: "名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "marketValueDisplay",
                label: "总市值"
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableAmountDisplay",
                label: "可用"
              }),
              _createVNode(_component_el_table_column, {
                prop: "currentAmountDisplay",
                label: "持有"
              }),
              _createVNode(_component_el_table_column, {
                prop: "costPriceDisplay",
                label: "成本"
              }, {
                header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "text-icon" }, [
                    _createElementVNode("span", null, "成本")
                  ], -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "currentPriceDisplay",
                label: "现价"
              }),
              _createVNode(_component_el_table_column, { label: "盈亏" }, {
                header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "text-icon" }, [
                    _createElementVNode("span", null, "盈亏")
                  ], -1)
                ]))]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(formatIncomeBalanceColor(scope.row.incomeBalanceDisplay))
                  }, _toDisplayString(scope.row.incomeBalanceDisplay), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass(formatIncomeBalanceColor(scope.row.incomeBalanceDisplay))
                  }, _toDisplayString(scope.row.incomePercentDisplay), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "150",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: "buy-btn",
                      onClick: ($event: any) => (handleBuy(scope.row))
                    }, "买入", 8, _hoisted_3),
                    _createElementVNode("div", {
                      class: "sell-btn",
                      onClick: ($event: any) => (handleSell(scope.row))
                    }, "卖出", 8, _hoisted_4)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(loading)]
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(loading) && !stockPosPageList.value.length)
      ? (_openBlock(), _createBlock(TableEmpty, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})